var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"curso-main-container pb-3"},[_c('BannerInterno',{attrs:{"icono":"fas fa-tasks","titulo":"Actividad didáctica"}}),_c('div',{staticClass:"container tarjeta tarjeta--blanca p-4 p-md-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }